export default {
  sign_in_title: "登入您的帳戶",
  sign_up_title: "建立新帳戶",
  email: "電子郵箱地址",
  email_required: "請輸入您的電子郵箱地址",
  email_placeholder: "your{0}example.com",
  email_invalid: "請輸入有效的電子郵箱地址",
  password: "密碼",
  password_placeholder: "輸入您的密碼",
  password_required: "請輸入您的密碼",
  password_invalid: "密碼至少需要 8 個字元，並包含字母、數字和特殊字元",
  forgot_password: "忘記密碼？",
  confirm_password_required: "請確認您的密碼",
  confirm_password_placeholder: "確認密碼",
  passwords_do_not_match: "兩次輸入的密碼不一致",
  or: "或",
  no_account: "沒有帳戶？",
  have_account: "已有帳戶？",
  error: "登入失敗。請檢查您的電子郵箱和密碼。",
  google_error: "Google 登入失敗",
  x_error: "X 登入失敗",
  linkedin_error: "LinkedIn 登入失敗",
  google_sign_in: "使用 Google 登入",
  google_sign_up: "使用 Google 註冊",
  apple_sign_in: "使用 Apple 登入",
  apple_sign_up: "使用 Apple 註冊",
  twitter_sign_in: "使用 X 登入",
  twitter_sign_up: "使用 X 註冊",
  linkedin_sign_in: "使用 LinkedIn 登入",
  linkedin_sign_up: "使用 LinkedIn 註冊",
  aria_card: "登入卡片",
  aria_email: "電子郵箱輸入欄位",
  aria_password: "密碼輸入欄位",
  aria_submit: "提交按鈕",
  aria_google: "Google 登入按鈕",
  aria_linkedin: "LinkedIn 登入按鈕",
  aria_switch_mode: "切換登入/註冊模式",
  welcome: "歡迎來到 TaxEcoBit",
  subtitle: "歐盟 CBAM 合規碳稅計算平台",
  benefit1: "精確的碳稅計算，誤差小於 10%",
  benefit2: "支援多種運輸方式和自訂係數",
  benefit3: "支援 API 整合",
  benefit4: "生成符合歐盟 CBAM 要求的合規報告",
  user_friendly: "用戶友好",
  secure_reliable: "安全可靠",
  cloud_sync: "雲端同步",
  invite_code: "邀請碼",
  invite_code_placeholder: "請輸入邀請碼（選填）",
  invite_code_detected: "檢測到邀請碼",
  invited_by_user: "邀請人",
  sign_out: "登出",
  agreement_prefix: "註冊 TaxEcoBit 即表示您同意我們的",
  terms: "服務條款",
  and: "和",
  privacy: "隱私政策",
  agreement_required: "請先同意隱私政策",
  complete_verification: "請先完成驗證",
  loading_verification: "正在載入驗證...",
  verification_failed: "驗證失敗，請重試",
};
